import { Container, Grid, Typography, Box, } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import NewsRoomBackPR from '../../../Component/NewsRoomBackPR.js';
import { Helmet } from 'react-helmet';


import SPN from "../../../asset/images/media/sports-news.webp";
import NBN from "../../../asset/images/media/national-biz-news.webp";
import BNW from "../../../asset/images/media/business-news-week.webp";
import SBN from "../../../asset/images/media/smart_business_news.webp";
import BND from "../../../asset/images/media/biz_news_desk.webp";
import BNTW from "../../../asset/images/media/bntw.webp";
import MBTN from "../../../asset/images/media/media_bulletins.webp";
import WNW from "../../../asset/images/media/web-newswire.webp";
import CXO from "../../../asset/images/media/cxo-media.webp";
import BWP from "../../../asset/images/media/bwpeople.webp";
import FPR from "../../../asset/images/media/for_pressp_release.webp";
import NWP from "../../../asset/images/media/news_petrolling.webp";

export default function CSRInitiative() {

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        <>

            <Helmet>
                <meta charset="UTF-8" />
                <title>Decimal Point Analytics Hires Interns Full-Time Under CSR Initiative</title>
                <meta name="description" content="Decimal Point Analytics Hires Interns Full-Time Under CSR Initiative" />
                <link rel="canonical" href="https://www.decimalpointanalytics.com/decimal-point-analytics-hires-interns-full-time-under-csr-initiative" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>


            <Box className='section sec_bg' component='section'>
                <Container maxWidth='lg' className='bdr'>


                    <Grid container spacing={1} alignItems="top" justifyContent='center'>
                        <Grid item lg={10} md={10} sm={12} xs={12}>
                            <Box>
                                <Typography variant='h2' className='subhead skblue al_center'>
                                    News Room
                                </Typography>
                                <Typography variant='h1' className='mainhead blue al_center'>
                                    Decimal Point Analytics Hires Interns Full-Time Under CSR Initiative
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    <Box>
                        <Grid container direction="row"
                            justifyContent="center"
                            alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box className='whitebx'>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        <strong>Decimal Point Analytics</strong> has successfully transitioned six interns into full time employees under its CSR initiative, <strong>‘Dnyanodapi Dhanodapi.’</strong> This annual program, now in its third edition, is dedicated to providing corporate exposure to deserving young minds from rural and economically disadvantaged backgrounds who often lack access to professional training and career-building opportunities. The initiative bridges this gap by nurturing high-potential students, equipping them with industry-relevant skills, and integrating them into the corporate ecosystem.
                                    </Typography>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        The 2024 selection process saw a remarkable response, with 483 candidates applying across six campuses. From this pool, 85 candidates were shortlisted for interviews and interactions, culminating in the final selection of six students. Notably, the program achieved a female-to-male ratio of 2:1, reflecting Decimal Point Analytics‘ strong commitment to gender diversity. The growing number of applicants compared to previous years highlights the rising interest in financial analytics careers among talented students in rural areas.
                                    </Typography>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        Through a rigorous internship, these selected students gained hands-on experience in AI-driven financial analytics, exposure to industry best practices, and professional mentorship. Their exceptional performance and dedication have now led to six of them securing full–time employment with Decimal Point Analytics.
                                    </Typography>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        Speaking about the initiative, <strong>Shailesh Dhuri,</strong> CEO at Decimal Point Analytics, emphasized the importance of knowledge as true wealth that empowers individuals and drives progress. He highlighted that ‘Dnyanodapi Dhanodapi’ not only imparts industry-relevant skills but also ensures that young professionals, especially those from underserved regions, have a strong foundation to build their careers. Drawing an analogy to the commando training of armed forces, he remarked, <i>“Just as Army commando training transforms individuals from any background into the sharpest and most capable soldiers in the world, our initiative aims to bring deserving young minds from rural and poor backgrounds to the cutting edge of data analytics.”</i> Converting interns into full–time employees reaffirms the company’s commitment to nurturing talent and contributing to the community.
                                    </Typography>

                                    <Typography variant='h6' className='black jst' gutterBottom>
                                        This initiative aligns with Decimal Point Analytics‘ broader CSR vision of empowering the next generation by integrating education, technology, and career-building opportunities. By bridging the gap between academia and industry, the company continues to pave the way for young professionals to excel in the evolving world of AI-driven financial services.
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>


                    </Box>

                    <Box>
                        <Box className='graybbx' mt={2}>
                            <Grid container spacing={0} alignItems="center" justifyContent='center'>

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://sportsz.news/technology/decimal-point-analytics-hires-interns-full-time-under-csr-initiative/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + SPN + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://nationalbiznews.com/technology/decimal-point-analytics-hires-interns-full-time-under-csr-initiative/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + NBN + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://businessnewsweek.in/technology/decimal-point-analytics-hires-interns-full-time-under-csr-initiative/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + BNW + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://smartbusinesnews.com/technology/decimal-point-analytics-hires-interns-full-time-under-csr-initiative/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + SBN + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://biznewsdesk.com/technology/decimal-point-analytics-hires-interns-full-time-under-csr-initiative/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + BND + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://businessnewsthisweek.com/technology/decimal-point-analytics-hires-interns-full-time-under-csr-initiative/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + BNTW + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://mediabulletins.com/technology/decimal-point-analytics-hires-interns-full-time-under-csr-initiative/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + MBTN + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>

                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://www.webnewswire.com/2025/05/06/decimal-point-analytics-converts-interns-into-full-time-employees-under-its-csr-initiative-dnyanodapi-dhanodapi/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + WNW + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>

                                 <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://cxomedia.in/2025/05/06/from-internship-to-employment-decimal-point-analytics-dnyanodapi-dhanodapi-bridges-opportunity-gap/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + CXO + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>

                                 <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://www.bwpeople.in/article/decimal-point-analytics-hires-interns-through-csr-skill-initiative-555882" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + BWP + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>

                                 <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://www.forpressrelease.com/forpressrelease/651833/17/decimal-point-analytics-converts-interns-into-full-time-employees-under-its-csr-initiative" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + FPR + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>

                                 <Grid item lg={2} md={3} sm={4} xs={6}>
                                    <a href="https://newspatrolling.com/decimal-point-analytics-converts-interns-into-full-time-employees-under-its-csr-initiative-dnyanodapi-dhanodapi/" target="_blank" rel="noopener noreferrer">
                                        <Box
                                            className="awardsindexcircle"
                                            style={{ backgroundImage: "url(" + NWP + ")" }}
                                        ></Box>
                                    </a>
                                </Grid>

                            </Grid>
                        </Box>
                    </Box>


                    <Box mt={2}>
                        <NewsRoomBackPR />
                    </Box>

                </Container>
            </Box>





        </>
    );
}
